import NewLineText from './NewLineText';

export default NewLineText;
